import React from 'react';
import styled from '@emotion/styled';

import withTrackingPropsProvider from '../../../../hocs/withTrackingPropsProvider';

import AccountDrawer from './AccountDrawer';
import NavDrawer from './../NavDrawer';

import HeaderNav from './HeaderNav';

const TrackedContainer = withTrackingPropsProvider(styled.div``);

const TRACKING_PROPS = {
  block_name: 'masthead',
  block_row: 'masthead',
};

export default function MobileHeader({ nodes }) {
  return (
    <TrackedContainer tracking={TRACKING_PROPS}>
      <AccountDrawer />
      <NavDrawer nodes={nodes} />
      <HeaderNav />
    </TrackedContainer>
  );
}
